const API_BASE_URL = 'https://psychology-maps-2-0-backend.vercel.app/api';

export const loginUser = async (email, password) => {
  const response = await fetch(`${API_BASE_URL}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();
  return { response, data };
};

export const registerUser = async (email, password) => {
  const response = await fetch(`${API_BASE_URL}/login/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json();
  return { response, data };
};

// Announcements API
export const getAnnouncements = async () => {
  const response = await fetch(`${API_BASE_URL}/announcements`);
  const data = await response.json();
  return { response, data };
};

export const getAllAnnouncements = async () => {
  const response = await fetch(`${API_BASE_URL}/announcements/all`);
  const data = await response.json();
  return { response, data };
};

export const createAnnouncement = async (announcementData) => {
  const response = await fetch(`${API_BASE_URL}/announcements`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(announcementData),
  });
  const data = await response.json();
  return { response, data };
};

export const updateAnnouncement = async (id, announcementData) => {
  const response = await fetch(`${API_BASE_URL}/announcements/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(announcementData),
  });
  const data = await response.json();
  return { response, data };
};

export const deleteAnnouncement = async (id) => {
  const response = await fetch(`${API_BASE_URL}/announcements/${id}`, {
    method: 'DELETE',
  });
  const data = await response.json();
  return { response, data };
};

